import React, { Component } from "react";
import "./style.css";
import axios from "axios";
import { validationForEmail } from "../../js/regex";

class MailForwardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      receiver_email: "",
      receiver_name: "",
      sender_email: "",
      sender_name: "",
      errors: {},
      sending: false,
      showSuccessText: false,
    };
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {
        ...this.state.errors,
        [e.target.name]: null,
      },
    });
  };

  onFormSubmit = (e) => {
    e.preventDefault();

    this.setState({ sending: true });
    const {
      receiver_email,
      receiver_name,
      sender_email,
      sender_name,
    } = this.state;
    let errors = {};
    if (!validationForEmail(receiver_email)) {
      errors.receiver_email = "Invalid Email";
    }
    if (!validationForEmail(sender_email)) {
      errors.sender_email = "Invalid Email";
    }
    if (receiver_name.length === 0) {
      errors.receiver_name = "Name is required";
    }

    if (receiver_email.length === 0) {
      errors.receiver_email = "Email is required";
    }

    if (sender_name.length === 0) {
      errors.sender_name = "Name is required";
    }

    if (sender_email.length === 0) {
      errors.sender_email = "Email is required";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ sending: false });
      this.setState((state) => {
        return {
          ...state,
          errors: errors,
        };
      });
    } else {
      axios
        .post(`https://winpeforum.com/api/public/${this.props.url}`, {
          receiver_email,
          receiver_name,
          sender_email,
          sender_name,
          insight: this.props.insight,
        })
        .then((res) => {
          this.setState(
            {
              showSuccessText: true,
              sending: false,
              receiver_name: "",
              receiver_email: "",
              sender_name: "",
              sender_email: "",
            },
            function () {
              setTimeout(() => {
                this.setState({ showSuccessText: false });
                this.props.onClickClose();
              }, 5000);
            }
          );

          console.log(res.data);
        })
        .catch((e) => {
          this.setState({ sending: false });
          console.log(e);
        });
    }
  };
  render() {
    const { show, onClickClose } = this.props;
    const { errors, sending, showSuccessText } = this.state;
    return (
      <div
        className={`mail-forward-form ${show && " mail-forward-form--show"}`}
      >
        <button onClick={onClickClose} className="mail-forward-form__close">
          <i className="fa fa-times" />
        </button>
        <h2 className="mail-forward-form__heading">FORWARD ON EMAIL</h2>

        {showSuccessText ? (
          this.props.insight.length > 0 ? (
            <div className="mail-forward-form__success">
              <i
                className="fa fa-check"
                style={{ color: "green" }}
                aria-hidden="true"
              ></i>
              This Winpe Insights has been forwarded on email{" "}
            </div>
          ) : (
            <div className="mail-forward-form__success">
              <i
                className="fa fa-check"
                style={{ color: "green" }}
                aria-hidden="true"
              ></i>
              This Winpe Newsletter has been forwarded on email{" "}
            </div>
          )
        ) : (
          <form onSubmit={this.onFormSubmit}>
            <label>Receiver</label>
            <br />
            <input
              name="receiver_name"
              value={this.state.receiver_name}
              placeholder="Receiver's Full Name"
              onChange={this.handleInputChange}
            />
            {errors.receiver_name && (
              <span className="mail-forward-form__error">
                {errors.receiver_name}
              </span>
            )}
            <br />
            <input
              style={{ marginTop: "4px" }}
              name="receiver_email"
              placeholder="Receiver's Email Address"
              value={this.state.receiver_email}
              onChange={this.handleInputChange}
            />
            {errors.receiver_email && (
              <span className="mail-forward-form__error">
                {errors.receiver_email}
              </span>
            )}
            <br />
            <label>Sender</label>
            <br />
            <input
              name="sender_name"
              value={this.state.sender_name}
              placeholder="Sender's Full Name"
              onChange={this.handleInputChange}
            />
            {errors.sender_name && (
              <span className="mail-forward-form__error">
                {errors.sender_name}
              </span>
            )}
            <br />
            <input
              style={{ marginTop: "4px" }}
              name="sender_email"
              placeholder="Sender's Email Address"
              value={this.state.sender_email}
              onChange={this.handleInputChange}
            />
            {errors.sender_email && (
              <span className="mail-forward-form__error">
                {errors.sender_email}
              </span>
            )}
            <button className="mail-forward-form__submit">
              {sending ? "SENDING" : "SEND"}
            </button>
          </form>
        )}
      </div>
    );
  }
}

MailForwardForm.defaultProps = {
  show: false,
  onClickClose: () => {},
  url: "newsletter.php/2020/jul-sep",
  insight: "",
};
export default MailForwardForm;



// WEBPACK FOOTER //
// ./src/components/MailForwardForm/index.js